import { DataGrid, useGridApiContext, gridClasses, GridActionsCellItem } from "@mui/x-data-grid";
import styles from './AppVersions.module.css';
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import React , { useMemo, useCallback } from "react";
import { DeleteOutline, Done, FileDownloadOutlined, HideSource, Tune } from "@mui/icons-material";
import { DialogActionItem } from "components/grid";
import { Typography } from "@mui/material";
import { HidingError } from "components/errors";
import { isoToDateString, isoToDateTimeString } from "utils/date";
import StrippedDataGrid from "components/styled";

const ecrModels = ["TPS570Q", "TPS570"];

const CustomEditComponent = (props) => {
  const { id, value, field } = props;
  const apiRef = useGridApiContext();

  const handleChange = (event) => {
    const eventValue = event.target.value; // The new value entered by the user
    const newValue = typeof eventValue === "string" ? value.split(",") : eventValue;
    apiRef.current.setEditCellValue({
      id,
      field,
      value: newValue.filter((x) => x !== "")
    });
  };

  const handleClose = (event) => apiRef.current.stopCellEditMode({ id, field });

  return (
    <Select
      labelId="demo-multiple-name-label"
      id="demo-multiple-name"
      multiple
      value={value}
      onChange={handleChange}
      onClose={handleClose}
      sx={{ width: "100%" }}
    >
      {ecrModels.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  );
}
const EnabledEcrsEditCell = (params) => <CustomEditComponent {...params} />;


const beforeIconPickerCell = ({value}) => {
  return ( <div className={styles.forEcrs}>
            <Tune sx={{mx: 1, color: 'rgba(0, 0, 0, 0.87)', cursor: 'pointer'}}/>
            <div>{value ? value.join(', ') : ''}</div>
          </div>
  );
};


const AppVersions = ({name, packageName, data, ecrModels, onChange}) => { 

  const hideError = () => {
    
  };

  const openError = () => { 
    
  };

  const getErrorMessage = () => {
    return'Ошибка';
  };

  const download = useCallback( (id) => {
    console.log('download', id);
  }, []);

  const setDisabled = useCallback( (row) => {
    const index = data.findIndex(el => el.id === row.id);
    if(index !== -1) {
      onChange([...data.slice(0, index), {...row, disabled: !row.disabled}, ...data.slice(index + 1)]);
    }
  }, [data]);

  const setDeleted = useCallback( (row) => {
    const index = data.findIndex(el => el.id === row.id);
    if(index !== -1) {
      onChange([...data.slice(0, index), {...row, deleted: !row?.deleted}, ...data.slice(index + 1)]);
    }
  }, [data]);

  /*const remove = useCallback( (row) => {
    const index = data.findIndex(el => el.id === row.id);
    if(index !== -1) { 
      onChange([...data.slice(0, index), ...data.slice(index + 1)]);
    }
  }, [data]);*/

  const processRowUpdate = useCallback((updatedRow, originalRow) =>   {
      const index = data.findIndex(el => el.id === updatedRow.id);
      if(index !== -1) {
        onChange([...data.slice(0, index), updatedRow, ...data.slice(index + 1)]);
        return updatedRow;
      }
      return originalRow;
    }, [data]);


  const handleProcessRowUpdateError = (error) => {
    console.log('error from handleProcessRowUpdateError', error);
  };

  const rowClassName = (row, indexRelativeToCurrentPage) => {
    let result = indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
    row.disabled && (result += ' disabled');
    row.deleted && (result += ' deleted');
    return result;
  };

  const columns = useMemo(
    () => [
      { field: 'uploaded', headerName: "Добавлено", width: 120, type: "date",  valueFormatter: (v) => isoToDateString(v) },
      { field: 'version', headerName: "Версия", type: "string", align: 'center', headerAlign: 'center' },  
      { field: 'build', headerName: "Сборка", type: "number" },
      { field: 'size', headerName: "Размер", type: "number", valueGetter: (value) => (value/1024/1024).toFixed(2),
          valueFormatter: (value) => `${value} Мб`},
      { field: "enabledEcrs", headerName: 'Для касс', type: "singleSelect", flex: 1, editable: true, headerAlign: 'center', 
          valueOptions: ecrModels, renderCell: beforeIconPickerCell, renderEditCell: EnabledEcrsEditCell },
      {
        field: 'actions', width: 130, type: 'actions', getActions: ({row}) => [ 
            <DialogActionItem 
              icon={ <FileDownloadOutlined />} 
              label="download"
              handler={()=>download(row)}
              title='Скачать приложение'
            >
                <span>Скачать приложение <b>{name}</b> версии <b>{row.version}</b>?</span>                
            </DialogActionItem>,
            <DialogActionItem
              icon={ row.disabled ? <Done /> : <HideSource />}
              label={ row.disabled ? "Разблокировать" : "Заблокировать" }
              handler={()=>setDisabled(row)}
              title={row.disabled ? 'Разблокировать приложение': 'Заблокировать приложение'}
            >
              <span>{row.disabled ? 'Разблокировать' : 'Заблокировать'} приложение <b>{name}</b> версии <b>{row.version}</b>?</span>                
            </DialogActionItem>,
            <DialogActionItem
              icon={ <DeleteOutline />}
              label={ row.deleted ? "Восстановить" : "Удалить" }
              handler={ ()=>setDeleted(row) }
              title={row.deleted ? 'Восстановить приложение' : 'Удалить приложение'}
            >
              <span>{row.deleted ? 'Восстановить' : 'Удалить'} приложение <b>{name}</b> версии <b>{row.version}</b>?</span>                
            </DialogActionItem>
          ]
      }
    ],
    [download, setDisabled, setDeleted]
  );

  return (
    <>
      <HidingError 
        open={ openError() }
        message={ getErrorMessage() }
        onClose={hideError}
      />
      <StrippedDataGrid 
        experimentalFeatures={{newEditingApi: true}}
        columns={columns}
        rows={data}
        localeText={{noRowsLabel: "Приложений пока нет"}}
        getRowClassName={({row, indexRelativeToCurrentPage}) => rowClassName(row, indexRelativeToCurrentPage)}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={handleProcessRowUpdateError}
        hideFooter
        disableColumnMenu
        sx={{
          width: '100%',
          [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
            outline: 'none',
          },
          [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
            outline: 'none',
          },
          [`& .${gridClasses.columnHeader}, & .MuiInputBase-root`]: {
            overflowX: 'unset'
          },
          [`& .MuiInputBase-root.MuiOutlinedInput-root`]: {
            fontSize: '0.9rem'
          },
          [`& .${gridClasses.cell}.${gridClasses["cell--editing"]}:focus, & .${gridClasses.cell}.${gridClasses["cell--editing"]}:focus-within`]: {
            outline: 'none'
          },
          [`& .disabled.${gridClasses.row}, & .disabled.${gridClasses.row}:hover`]: {
            backgroundColor: 'rgba(0, 0, 0, 0.33)'
          }
        }}
      />
    </>
    
  );
};

export default AppVersions;